export const layout = {
    settings: {
        layout_type: "ltr",
        layout: "default",
        sidebar_icon: "stroke-svg",
        sidebar_setting: "compact-wrapper"
    },
    color: {
        layout_version: "light",
        primary_color: "#7A70BA",
        secondary_color: "#48A3D7"
    }
}